import { setReports } from '../../store/actions'

const mapStateToProps = (state) => ({
  reports: state.reports.reports,
  showDatePickerReports: state.reports.showDatePickerReports
});

const mapDispatchToProps = {
  setReports,
}

export { mapStateToProps, mapDispatchToProps };
